module.exports = __webpack_public_path__ + "img/roll_l_a9.c8492b30.png";